<template>
    <div class="card">
        
        <div class="card-header">{{ location.type ? location.type : 'Type Unknown' }}</div>        
        
        <div class="card-body">
            <router-link :to="{ name : 'location', params:{ id: location.id }}" class="routerlink">
                <a>{{ location.name }}</a>
            </router-link>
        </div>

        <div class="card-footer">
            {{ location.dimension !=='unknown' ? location.dimension : 'Dimension Unknown' }}
        </div>

    </div>
</template>

<script>
import { onMounted } from 'vue'
export default {
    props: ['location'],
    setup( props ) {
        onMounted(  () => { console.log( 'LocationsList Mounted' ) } )
    }
}
</script>

<style>

</style>